'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseResizableDirectiveController=require('../../../../dist-es6/client/angularCommon/baseResizableDirectiveController');let

TextTicksDirective=class TextTicksDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['tickProvider','tickFormatter','axis','fontSize'];
}

get textBindings(){
return['textAnchor'];
}

get controller(){
return TextTicksDirectiveController;
}};let


TextTicksDirectiveController=class TextTicksDirectiveController extends BaseResizableDirectiveController{
static get $inject(){return['$scope','$element','$window']}

constructor($scope,$element,$window){
super($scope,$element,$window);
this._svgElement=null;
$scope.$watch('controller.axis',()=>{
if(_.exists(this.axis)){
let dimensionToWatch=this.axis.orientation==='horizontal'?'width':'height';
$scope.$watch(`controller.dimensions.${dimensionToWatch}`,()=>this._render());
$scope.$watch('controller.axis.scale',()=>this._render());
}
});
}

_render(){
if(!this._dimensionsValid){
return;
}

if(!_.exists(this.axis)||!_.exists(this.axis.scale)){
return;
}

this._refreshSvg();

let ticks=this.tickProvider(this.axis);

let tickAxis=d3.svg.axis().
scale(this.axis.scale).
orient(this.axis.orientation==='horizontal'?'top':'right').
tickFormat(this.tickFormatter);

switch(ticks.type){
case'values':
tickAxis=tickAxis.tickValues(ticks.values);
break;
case'd3Calculated':
tickAxis=tickAxis.ticks(d3.time[ticks.interval],ticks.step);
break;
default:
throw new Error('unknown ticks type');}


let axisElements=d3.select(this._svgElement).append('g').
attr('transform',`translate(0, ${this.axis.orientation==='horizontal'?this.fontSize:0})`).
attr('class','text-ticks').
call(tickAxis);

axisElements.selectAll('text').
attr({
x:'0',
y:'0'}).

style({
"font-size":`${this.fontSize}px`,
"text-anchor":this.textAnchor||'start'});

axisElements.selectAll('path').remove();
}

_refreshSvg(){
if(_.exists(this._svgElement)){
angular.element(this._svgElement).remove();
}

this._$element.append(`<svg width="${this.dimensions.width}" height="${this.dimensions.height}"></svg>`);
this._svgElement=this._$element[0].getElementsByTagName('svg')[0];
}};


module.exports=TextTicksDirective;
//# sourceMappingURL=textTicksDirective.js.map
